import { RoleInterface, RoleInterfaceMap } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';
// LINK - apps/server/src/API/Roles/Roles.Controller.ts
export class RolesAPI {
  static async loadRoles(orgId: number) {
    return APIService.Server.get<{
      parentRoles: RoleInterfaceMap;
      roles: RoleInterfaceMap;
    }>(`/roles/org/${orgId}`);
  }

  static async updateRole(
    orgId: number,
    roleId: number,
    role: Partial<RoleInterface>
  ) {
    return APIService.Server.put<RoleInterface>(
      `/roles/org/${orgId}/role/${roleId}`,
      role
    );
  }
  static async createRole(orgId: number, name: string, parentSlug?: string) {
    return APIService.Server.post<RoleInterface>(
      `/roles/org/${orgId}/role`,
      { name, parentSlug }
    );
  }
  static async deleteRole(orgId: number, roleId: number) {
    return APIService.Server.delete<boolean>(
      `/roles/org/${orgId}/role/${roleId}`
    );
  }
}
